// Serviço de Webhook (100% gratuito)
export const webhookService = {
  // URLs de webhook gratuitas (configure com suas URLs reais)
  WEBHOOK_URLS: {
    SLACK: 'https://hooks.slack.com/services/T00000000/B00000000/XXXXXXXXXXXXXXXXXXXXXXXX', // Configure sua URL do Slack
    DISCORD: 'https://discord.com/api/webhooks/000000000000000000/XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX', // Configure sua URL do Discord
    TELEGRAM: 'https://api.telegram.org/bot8214145484:AAEOaPMX2Dar51_nnzBqFKnudgNodSGjJNs/sendMessage', // Substitua <SEU_BOT_TOKEN_AQUI> pelo token do BotFather
    IFTTT: 'https://maker.ifttt.com/trigger/playkids_contract/with/key/YOUR_KEY', // Configure sua chave do IFTTT
  },

  // Configurações do Telegram
  TELEGRAM_CONFIG: {
    BOT_TOKEN: '8214145484:AAEOaPMX2Dar51_nnzBqFKnudgNodSGjJNs', // Token do BotFather
    CHAT_ID: '5262956966', // Chat ID do @userinfobot
  },

  // URLs de teste que funcionam sem CORS
  TEST_URLS: {
    JSON_PLACEHOLDER: 'https://jsonplaceholder.typicode.com/posts', // URL de teste que aceita CORS
    HTTPBIN: 'https://httpbin.org/post', // URL de teste que aceita CORS
    REQUESTBIN: 'https://requestbin.com/r/YOUR_BIN_ID', // Configure seu RequestBin
  },

  // Enviar webhook
  async sendWebhook(url: string, data: any): Promise<boolean> {
    try {
      console.log('🔗 Enviando webhook para:', url);
      console.log('🔗 Dados:', data);

      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data)
      });

      if (response.ok) {
        const responseData = await response.json();
        console.log('✅ Webhook enviado com sucesso');
        console.log('✅ Resposta:', responseData);
        return true;
      } else {
        const errorText = await response.text();
        console.error(`❌ Erro ao enviar webhook: ${response.status} - ${errorText}`);
        console.error('❌ Dados enviados:', JSON.stringify(data, null, 2));
        return false;
      }
    } catch (error) {
      console.error('❌ Erro ao enviar webhook:', error);
      return false;
    }
  },

  // Enviar para Slack
  async sendToSlack(contract: any): Promise<boolean> {
    try {
      const nomeContratante = contract.contratante || 'Não informado';
      const nomeAniversariante = contract.nomeAniversariante || 'Não informado';
      const dataFesta = contract.dataFesta ? new Date(contract.dataFesta).toLocaleDateString('pt-BR') : 'Não informada';
      const telefone = contract.telefone || 'Não informado';
      const valor = contract.valor ? `R$ ${contract.valor}` : 'A definir';

      const slackMessage = {
        text: '🎉 Novo Contrato Recebido - PlayKids',
        attachments: [
          {
            color: 'good',
            fields: [
              {
                title: '👤 Contratante',
                value: nomeContratante,
                short: true
              },
              {
                title: '📞 Telefone',
                value: telefone,
                short: true
              },
              {
                title: '🎂 Aniversariante',
                value: nomeAniversariante,
                short: true
              },
              {
                title: '📅 Data',
                value: dataFesta,
                short: true
              },
              {
                title: '💰 Valor',
                value: valor,
                short: true
              },
              {
                title: '⏰ Recebido em',
                value: new Date().toLocaleString('pt-BR'),
                short: true
              }
            ]
          }
        ]
      };

      return await this.sendWebhook(this.WEBHOOK_URLS.SLACK, slackMessage);
    } catch (error) {
      console.error('❌ Erro ao enviar para Slack:', error);
      return false;
    }
  },

  // Enviar para Discord
  async sendToDiscord(contract: any): Promise<boolean> {
    try {
      const nomeContratante = contract.contratante || 'Não informado';
      const nomeAniversariante = contract.nomeAniversariante || 'Não informado';
      const dataFesta = contract.dataFesta ? new Date(contract.dataFesta).toLocaleDateString('pt-BR') : 'Não informada';
      const telefone = contract.telefone || 'Não informado';
      const valor = contract.valor ? `R$ ${contract.valor}` : 'A definir';

      const discordMessage = {
        content: '🎉 **Novo Contrato Recebido - PlayKids**',
        embeds: [
          {
            title: 'Detalhes do Contrato',
            color: 0x00ff00,
            fields: [
              {
                name: '👤 Contratante',
                value: nomeContratante,
                inline: true
              },
              {
                name: '📞 Telefone',
                value: telefone,
                inline: true
              },
              {
                name: '🎂 Aniversariante',
                value: nomeAniversariante,
                inline: true
              },
              {
                name: '📅 Data',
                value: dataFesta,
                inline: true
              },
              {
                name: '💰 Valor',
                value: valor,
                inline: true
              },
              {
                name: '⏰ Recebido em',
                value: new Date().toLocaleString('pt-BR'),
                inline: true
              }
            ],
            timestamp: new Date().toISOString()
          }
        ]
      };

      return await this.sendWebhook(this.WEBHOOK_URLS.DISCORD, discordMessage);
    } catch (error) {
      console.error('❌ Erro ao enviar para Discord:', error);
      return false;
    }
  },

  // Verificar informações do bot
  async getBotInfo(): Promise<any> {
    try {
      const url = `https://api.telegram.org/bot${this.TELEGRAM_CONFIG.BOT_TOKEN}/getMe`;
      const response = await fetch(url);
      const data = await response.json();
      console.log('🤖 Informações do bot:', data);
      return data;
    } catch (error) {
      console.error('❌ Erro ao obter informações do bot:', error);
      return null;
    }
  },

  // Teste simples para verificar se o bot funciona
  async testSimpleMessage(): Promise<boolean> {
    try {
      console.log('🧪 Testando mensagem simples...');
      
      const simpleMessage = {
        chat_id: parseInt(this.TELEGRAM_CONFIG.CHAT_ID),
        text: `🧪 Teste Simples - ${new Date().toLocaleString('pt-BR')}

Se você recebeu esta mensagem, o bot está funcionando!`
      };

      const telegramUrl = `https://api.telegram.org/bot${this.TELEGRAM_CONFIG.BOT_TOKEN}/sendMessage`;
      const result = await this.sendWebhook(telegramUrl, simpleMessage);
      
      console.log('🧪 Resultado do teste simples:', result);
      return result;
    } catch (error) {
      console.error('❌ Erro no teste simples:', error);
      return false;
    }
  },

  // Enviar para Telegram
  async sendToTelegram(contract: any): Promise<boolean> {
    try {
      console.log('🤖 Enviando para Telegram...');
      console.log('🤖 Bot Token:', this.TELEGRAM_CONFIG.BOT_TOKEN.substring(0, 10) + '...');
      console.log('🤖 Chat ID:', this.TELEGRAM_CONFIG.CHAT_ID);

      // Verificar se está configurado
      if (this.TELEGRAM_CONFIG.BOT_TOKEN === 'SEU_BOT_TOKEN_AQUI' || this.TELEGRAM_CONFIG.CHAT_ID === 'SEU_CHAT_ID_AQUI') {
        console.log('⚠️ Telegram não configurado. Configure BOT_TOKEN e CHAT_ID em webhookService.ts');
        return false;
      }

      // Verificar se o bot está funcionando
      console.log('🤖 Verificando informações do bot...');
      const botInfo = await this.getBotInfo();
      
      if (!botInfo || !botInfo.ok) {
        console.error('❌ Bot não está funcionando ou token inválido');
        return false;
      }

      console.log('✅ Bot está funcionando:', botInfo.result.first_name);

      // Construir mensagem completa
      const nomeContratante = contract.contratante || 'Não informado';
      const nomeAniversariante = contract.nomeAniversariante || 'Não informado';
      const dataFesta = contract.dataFesta ? new Date(contract.dataFesta).toLocaleDateString('pt-BR') : 'Não informada';
      const telefone = contract.telefone || 'Não informado';
      const endereco = contract.endereco ? `${contract.endereco}, ${contract.numero || ''}` : 'Não informado';
      const cidade = contract.cidade && contract.estado ? `${contract.cidade} - ${contract.estado}` : 'Não informado';
      const horario = contract.horarioInicioFesta || 'Não informado';
      const tema = contract.temaFesta || 'Não informado';
      const observacoes = contract.observacoes || 'Nenhuma observação';
      const valor = contract.valor ? `R$ ${contract.valor}` : 'A definir';

      // Primeiro, vamos testar sem Markdown para ver se funciona
      const telegramMessage = {
        chat_id: parseInt(this.TELEGRAM_CONFIG.CHAT_ID),
        text: `🎉 NOVO CONTRATO RECEBIDO - PlayKids

👤 Contratante: ${nomeContratante}
📞 Telefone: ${telefone}
🎂 Aniversariante: ${nomeAniversariante}
📅 Data da Festa: ${dataFesta}
🕐 Horário: ${horario}
📍 Endereço: ${endereco}
🏙️ Cidade: ${cidade}
🎨 Tema: ${tema}
💰 Valor: ${valor}
📝 Observações: ${observacoes}

⏰ Recebido em: ${new Date().toLocaleString('pt-BR')}

🔗 Links Úteis:
• Ver Detalhes: https://playkidseventos.com.br/admin/contratos/${contract.id}
• Criar Orçamento: https://playkidseventos.com.br/admin/contratos/orcamento/${contract.id}
• Editar Contrato: https://playkidseventos.com.br/admin/contratos/editar/${contract.id}

💬 Responda rapidamente para não perder a venda!`
      };

      console.log('🤖 Enviando mensagem completa...');
      console.log('🤖 Dados da mensagem:', JSON.stringify(telegramMessage, null, 2));

      // Usar URL completa do Telegram
      const telegramUrl = `https://api.telegram.org/bot${this.TELEGRAM_CONFIG.BOT_TOKEN}/sendMessage`;
      console.log('🤖 URL do Telegram:', telegramUrl.substring(0, 50) + '...');
      
      const result = await this.sendWebhook(telegramUrl, telegramMessage);
      console.log('🤖 Resultado do envio:', result);
      
      if (!result) {
        console.error('❌ Falha ao enviar mensagem para Telegram');
        console.error('❌ Verifique se o bot foi iniciado com /start');
        console.error('❌ Verifique se o Chat ID está correto:', this.TELEGRAM_CONFIG.CHAT_ID);
      }
      
      return result;
    } catch (error) {
      console.error('❌ Erro ao enviar para Telegram:', error);
      return false;
    }
  },

  // Enviar para IFTTT
  async sendToIFTTT(contract: any): Promise<boolean> {
    try {
      const nomeContratante = contract.contratante || 'Não informado';
      const nomeAniversariante = contract.nomeAniversariante || 'Não informado';
      const dataFesta = contract.dataFesta ? new Date(contract.dataFesta).toLocaleDateString('pt-BR') : 'Não informada';

      const iftttMessage = {
        value1: nomeContratante,
        value2: nomeAniversariante,
        value3: dataFesta
      };

      return await this.sendWebhook(this.WEBHOOK_URLS.IFTTT, iftttMessage);
    } catch (error) {
      console.error('❌ Erro ao enviar para IFTTT:', error);
      return false;
    }
  },

  // Enviar notificação de novo contrato (tenta todos os webhooks)
  async sendNewContractNotification(contract: any): Promise<boolean> {
    try {
      const results = await Promise.allSettled([
        this.sendToSlack(contract),
        this.sendToDiscord(contract),
        this.sendToTelegram(contract),
        this.sendToIFTTT(contract)
      ]);

      const successCount = results.filter(result => 
        result.status === 'fulfilled' && result.value === true
      ).length;

      console.log(`✅ Webhooks enviados: ${successCount}/${results.length}`);
      return successCount > 0;
    } catch (error) {
      console.error('❌ Erro ao enviar webhooks:', error);
      return false;
    }
  },

  // Testar webhook com URL que aceita CORS
  async testWebhookCORS(contract: any): Promise<boolean> {
    try {
      const testData = {
        title: 'Teste Webhook - PlayKids',
        body: `Novo contrato: ${contract.contratante || 'Teste'}`,
        userId: 1,
        timestamp: new Date().toISOString(),
        contract: {
          contratante: contract.contratante || 'Teste',
          nomeAniversariante: contract.nomeAniversariante || 'João',
          dataFesta: contract.dataFesta || new Date().toISOString(),
          telefone: contract.telefone || '33999999999',
          valor: contract.valor || '500,00'
        }
      };

      // Testar com JSONPlaceholder (aceita CORS)
      const success = await this.sendWebhook(this.TEST_URLS.JSON_PLACEHOLDER, testData);
      
      if (success) {
        console.log('✅ Webhook de teste enviado com sucesso!');
        console.log('📊 Dados enviados:', testData);
        return true;
      } else {
        console.log('⚠️ Webhook de teste falhou, mas isso é normal para URLs de exemplo');
        return false;
      }
    } catch (error) {
      console.error('❌ Erro ao testar webhook:', error);
      return false;
    }
  },

  // Enviar para RequestBin (funciona sem CORS se configurado)
  async sendToRequestBin(contract: any): Promise<boolean> {
    try {
      const nomeContratante = contract.contratante || 'Não informado';
      const nomeAniversariante = contract.nomeAniversariante || 'Não informado';
      const dataFesta = contract.dataFesta ? new Date(contract.dataFesta).toLocaleDateString('pt-BR') : 'Não informada';
      const telefone = contract.telefone || 'Não informado';
      const valor = contract.valor ? `R$ ${contract.valor}` : 'A definir';

      const requestBinData = {
        event: 'new_contract',
        timestamp: new Date().toISOString(),
        data: {
          contratante: nomeContratante,
          nomeAniversariante: nomeAniversariante,
          dataFesta: dataFesta,
          telefone: telefone,
          valor: valor,
          source: 'PlayKids System'
        }
      };

      return await this.sendWebhook(this.TEST_URLS.REQUESTBIN, requestBinData);
    } catch (error) {
      console.error('❌ Erro ao enviar para RequestBin:', error);
      return false;
    }
  },

  // Verificar se webhook está configurado
  isWebhookConfigured(service: 'SLACK' | 'DISCORD' | 'TELEGRAM' | 'IFTTT'): boolean {
    if (service === 'TELEGRAM') {
      return this.TELEGRAM_CONFIG.BOT_TOKEN !== 'SEU_BOT_TOKEN_AQUI' && 
             this.TELEGRAM_CONFIG.CHAT_ID !== 'SEU_CHAT_ID_AQUI';
    }
    
    const url = this.WEBHOOK_URLS[service];
    return !url.includes('00000000') && !url.includes('<BOT_TOKEN>') && !url.includes('YOUR_KEY');
  },

  // Obter status dos webhooks
  getWebhookStatus(): { [key: string]: boolean } {
    return {
      slack: this.isWebhookConfigured('SLACK'),
      discord: this.isWebhookConfigured('DISCORD'),
      telegram: this.isWebhookConfigured('TELEGRAM'),
      ifttt: this.isWebhookConfigured('IFTTT'),
      requestbin: !this.TEST_URLS.REQUESTBIN.includes('YOUR_BIN_ID')
    };
  }
};
